import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './contexts/UserContext';
import { ThemeProvider } from './contexts/ThemeContext';
import GoogleLogin from './components/GoogleLogin';
import TravelConcierge from './components/TravelConcierge';
import ThemeToggle from './components/ThemeToggle';
import CompanyPage from './pages/CompanyPage';
import { AppErrorBoundary } from './components/boundaries/AppErrorBoundary';

const MainAppContent: React.FC = () => {
  const { user, loading } = useUser();
  const [loginError, setLoginError] = useState<string | null>(null);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-2xl text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div>
        <GoogleLogin 
          onError={setLoginError}
        />
        {loginError && (
          <div className="fixed top-4 right-4 bg-destructive text-destructive-foreground p-4 rounded-lg shadow-lg border border-border">
            {loginError}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <ThemeToggle />
      <TravelConcierge />
    </>
  );
};

const AppContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/company" element={<CompanyPage />} />
      <Route path="/about" element={<Navigate to="/company" />} />
      <Route path="/" element={<MainAppContent />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AppErrorBoundary>
      <ThemeProvider>
        <Router>
          <UserProvider>
            <AppContent />
          </UserProvider>
        </Router>
      </ThemeProvider>
    </AppErrorBoundary>
  );
};

export default App;